import React, { useEffect, useState } from "react";
import SidebarLinks from "./SidebarLinks";
import { Controller, useForm } from "react-hook-form";
import {
  CHANGEPASSWORD_API,
  GET_USER_PROFILE_API,
  UPDATE_USER_PROFILE_API,
} from "../app/constants";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "..";
import axios from "axios";
import BtnLoader from "./BtnLoader";
import Notification from "../helper/Notification";

const ProfileSection = () => {
  const [profile, setProfile] = useState({});
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isMessage, setIsMessage] = useState(null); // Stores message for notification
  const [showNotification, setShowNotification] = useState(false); // Toggle notification visibility
  const [notificationTitle, setNotificationTitle] = useState("Failed"); // Default to "Failed"

  const [newProfile, setNewProfile] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    birthdayDay: "",
    birthdayMonth: "",
    birthdayYear: "",
    gender: "",
  });

  const token = localStorage.getItem("accessToken");

  const fetchUserProfile = () => {
    axios
      .get(`${BASE_URL}${GET_USER_PROFILE_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.code === 1) {
          setProfile(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user profile:", error);
      });
  };

  // setLogoutConfirmed(true);

  const handleEditProfile = () => {
    setIsFormVisible(true);
    reset({
      fullName: profile.name || "",
      email: profile.email || "",
      phoneNumber: profile.phoneNumber.substring(3) || "",
      birthdayDay: profile.birthday?.day || "",
      birthdayMonth: profile.birthday?.month || "",
      birthdayYear: profile.birthday?.year || "",
      gender: profile.gender || "",
    });
  };

  const updateUserProfile = (values) => {
    if (!isValid) {
      return;
    }

    const profileData = {
      id: profile.id,
      email: values.email || profile.email,
      name: values.fullName || profile.name,
      city: values.city || profile.city,
      phoneNumber: values.phoneNumber || profile.phoneNumber,
      birthday: {
        day: values.birthdayDay || profile.birthday?.day,
        month: values.birthdayMonth || profile.birthday?.month,
        year: values.birthdayYear || profile.birthday?.year,
      },
      gender: values.gender || profile.gender,
    };

    console.log("Profile data being sent:", profileData);

    axios
      .put(`${BASE_URL}${UPDATE_USER_PROFILE_API}`, profileData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("Response:", response);

        if (response.status === 200 && response.data.code === 1) {
          setIsFormVisible(false);
          setPopupVisible(true);
        } else {
          // Error case when response.data.code !== 1
        }
      })
      .catch((error) => {
        console.error("Error updating profile:", error);
      });
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProfile({
      ...newProfile,
      [name]: value,
    });
  };

  // change password login is here
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const navigate = useNavigate();

  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  // Toggle password visibility
  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const {
    register,
    reset,
    control,
    handleSubmit,
    watch,
    formState: { errors, isValid },
    getValues,
  } = useForm({ mode: "onChange" });

  const email = sessionStorage.getItem("email");

  const onSubmit = async (data) => {
    const { oldPassword, newPassword, confirmPassword } = data;
    setIsLoading(true);

    // Ensure passwords match
    if (newPassword !== confirmPassword) {
      setIsLoading(false);
      setShowNotification(true); // Show notification
      return;
    }

    try {
      // Sending API request to change the password
      const response = await axios.post(`${BASE_URL}${CHANGEPASSWORD_API}`, {
        email,
        oldPassword,
        newPassword,
      });

      if (response?.status === 200) {
        const { message, code } = response.data || {};

        setIsMessage(message); // Use only the message from the API response
        setShowNotification(true); // Show notification

        // Set the title based on the response code
        setNotificationTitle(code === 1 ? "Password Updated" : "OTP Required");

        if (code === 1) {
          handleCloseModal(); // Close modal on success
        } else if (code === 0) {
          navigate("/otp-verification"); // Navigate if OTP is needed
        }
      } else {
        setIsMessage(response.data.message); // Show the message from API if status is not 200
        setShowNotification(true);
        setNotificationTitle("Failed"); // Default failure message
      }
    } catch (err) {
      // Show the error message directly from the API response (if available)
      const errorMessage =
        err.response?.data?.message || "Failed to update profile.";
      setIsMessage(errorMessage);
      setShowNotification(true); // Show notification with the error message
      setNotificationTitle("Failed"); // Default failure message
    } finally {
      setIsLoading(false); // Ensure loading state is turned off after the process
    }
  };

  const validatePassword = (value) => {
    return value.length >= 8 || "Password must be at least 8 characters long.";
  };

  const [isPopupVisible, setPopupVisible] = useState(false);

  const handleLogout = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");

    navigate("/login");
  };

  return (
    <section className="payment py-40 bg-light-100">
      <Notification
        show={showNotification}
        type="success"
        title={notificationTitle} // Use dynamic title
        message={isMessage}
        onClose={() => setShowNotification(false)}
      />
      <div className="container container-lg px-lg-5">
        <div className="row flex-row-reverse gy-4">
          <div className="col-xl-9 col-lg-8 pb-10 px-24 text-capitalize">
            <h4 className="fw-medium">My Profile</h4>
            <div className="bg-white p-30">
              <div className="d-flex flex-wrap">
                {/* Full Name */}
                <div style={{ minWidth: "20rem", minHeight: "8rem" }}>
                  <p className="text-sm text-black">Full Name</p>
                  <p className="text-xs text-muted my-4">{profile.name}</p>
                </div>
                {/* Email */}
                <div style={{ minWidth: "20rem", minHeight: "8rem" }}>
                  <p className=" text-sm text-black">Email </p>
                  <p className="text-xs text-muted my-4">{profile.email}</p>
                  <div className="d-flex align-items-center mt-2">
                    <input
                      className="form-check-input custom-checkbox cursor-pointer mx-4"
                      type="checkbox"
                      name=""
                      id=""
                    />
                    <p className="text-xs text-muted my-4 ms-2 mb-0">
                      receving marketing emails
                    </p>
                  </div>
                </div>
                {/* phoneNumber */}
                <div style={{ minWidth: "20rem", minHeight: "8rem" }}>
                  <p className=" text-sm text-black">Mobile</p>
                  <p className="text-xs text-muted my-4">
                    {profile.phoneNumber}
                  </p>
                </div>
                {/* Birthday */}
                <div style={{ minWidth: "20rem", minHeight: "8rem" }}>
                  <p className="text-sm text-black">Birthday</p>
                  <p className="text-xs text-muted my-4">
                    {profile.birthday || "Please enter your birthday"}
                  </p>
                </div>
                {/* Gender */}
                <div style={{ minWidth: "20rem", minHeight: "8rem" }}>
                  <p className="text-sm text-black">Gender</p>
                  <p className="text-xs text-muted my-4">
                    {profile.gender || "Please select your gender"}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-column align-items-start p-3">
                <button
                  className="btn rounded-0 text-xs btn-primary my-8"
                  style={{ minWidth: "14rem" }}
                  onClick={() => {
                    setIsFormVisible(true);
                    handleEditProfile();
                  }}
                >
                  EDIT PROFILE
                </button>
                <button
                  className="btn rounded-0 text-xs btn-primary my-8"
                  style={{ minWidth: "14rem" }}
                  onClick={handleShowModal}
                >
                  CHANGE PASSWORD
                </button>
              </div>
            </div>

            {/* Form start*/}
            {isFormVisible && (
              <div>
                {/* Overlay */}
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 z-3 bg-dark bg-opacity-75"
                  onClick={() => setIsFormVisible(false)}
                ></div>
                {/* Form Container */}
                <div
                  className="form-container bg-white px-24 py-24 shadow-lg position-fixed top-50 start-50 translate-middle w-md-90 w-lg-auto z-3"
                  style={{
                    width: "90%",
                    height: "90vh",
                    maxWidth: "700px",
                    overflowY: "auto",
                  }}
                >
                  <button
                    className="btn-close position-absolute top-0 end-0 m-24"
                    onClick={() => setIsFormVisible(false)}
                    aria-label="Close"
                  ></button>
                  <p className="text-lg text-black mb-4">Edit Profile</p>
                  <form onSubmit={handleSubmit(updateUserProfile)}>
                    <div className="row g-3">
                      {/* Full Name */}
                      <div className="col-12">
                        <label className="fw-light text-sm form-label">
                          Full Name
                        </label>
                        <input
                          className="text-sm fw-light form-control common-input rounded-0"
                          type="text"
                          {...register("fullName", {
                            required: "Full name is required",
                          })}
                          placeholder="Enter your full name"
                        />
                        {errors.fullName && (
                          <p className="text-danger text-xs">
                            {errors.fullName.message}
                          </p>
                        )}
                      </div>
                      {/* Email */}
                      <div className="col-12">
                        <label className="fw-light text-sm form-label">
                          Your Email
                        </label>
                        <input
                          className="text-sm fw-light form-control common-input rounded-0"
                          type="email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Invalid email address",
                            },
                          })}
                          placeholder="Enter your email"
                        />
                        {errors.email && (
                          <p className="text-danger text-xs">
                            {errors.email.message}
                          </p>
                        )}
                      </div>
                      {/* Phone Number */}
                      <div className="col-12">
                        <label className="fw-light text-sm form-label">
                          Phone Number
                        </label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            position: "relative",
                          }}
                        >
                          {/* Country Code */}
                          <div
                            style={{
                              position: "absolute",
                              left: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span className="text-sm">+92</span>
                            <div
                              style={{
                                borderLeft: "1px solid var(--gray-100)",
                                height: "20px",
                                marginLeft: "8px",
                              }}
                            ></div>
                          </div>

                          {/* phoneNumber Number Input */}
                          <Controller
                            name="phoneNumber"
                            control={control}
                            rules={{
                              required: "phone number is required",
                              minLength: {
                                value: 10,
                                message:
                                  "phone number number must be 10 digits",
                              },
                              pattern: {
                                value: /^3\d{9}$/,
                                message:
                                  "phone number number must start with '3'",
                              },
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e); // Propagate change to React Hook Form
                                  handleInputChange(e); // Your custom change handler
                                }}
                                onInput={(e) => {
                                  // Enforce max length in real-time
                                  if (e.target.value.length > 10) {
                                    e.target.value = e.target.value.slice(
                                      0,
                                      10
                                    );
                                  }
                                }}
                                type="number"
                                className="common-input text-sm rounded-0"
                                placeholder="Enter your phone number"
                                style={{
                                  paddingLeft: "60px", // To accommodate the country code
                                }}
                              />
                            )}
                          />
                        </div>

                        {/* Error message for phoneNumber */}
                        {errors.phoneNumber && (
                          <p className="text-xs text-danger">
                            {errors.phoneNumber.message}
                          </p>
                        )}
                      </div>

                      {/* Birthday */}
                      <div className="col-12">
                        <label className="fw-light text-sm form-label">
                          Birthday
                        </label>
                        <div className="d-flex gap-12 flex-wrap w-100">
                          <div>
                            <select
                              {...register("birthdayDay", {
                                required: "Day is required",
                              })}
                              className="form-control common-input rounded-0"
                              style={{ minWidth: "12rem" }}
                            >
                              <option value="">Day</option>
                              {[...Array(31)].map((_, i) => (
                                <option key={i + 1} value={i + 1}>
                                  {i + 1}
                                </option>
                              ))}
                            </select>
                            {errors.birthdayDay && (
                              <p className="text-danger text-xs">
                                {errors.birthdayDay.message}
                              </p>
                            )}
                          </div>
                          <div>
                            <select
                              {...register("birthdayMonth", {
                                required: "Month is required",
                              })}
                              className="form-control common-input rounded-0"
                              style={{ minWidth: "12rem" }}
                            >
                              <option value="">Month</option>
                              {[
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December",
                              ].map((month, i) => (
                                <option key={i} value={month}>
                                  {month}
                                </option>
                              ))}
                            </select>
                            {errors.birthdayMonth && (
                              <p className="text-danger text-xs">
                                {errors.birthdayMonth.message}
                              </p>
                            )}
                          </div>
                          <div>
                            <select
                              {...register("birthdayYear", {
                                required: "Year is required",
                              })}
                              className="form-control common-input rounded-0"
                              style={{ minWidth: "12rem" }}
                            >
                              <option value="">Year</option>
                              {[...Array(120)].map((_, i) => (
                                <option key={i} value={2023 - i}>
                                  {2023 - i}
                                </option>
                              ))}
                            </select>
                            {errors.birthdayYear && (
                              <p className="text-danger text-xs">
                                {errors.birthdayYear.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* Gender */}
                      <div className="col-12">
                        <label className="fw-light text-sm form-label">
                          Gender
                        </label>
                        <select
                          {...register("gender", {
                            required: "Gender is required",
                          })}
                          className="form-control common-input rounded-0"
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        {errors.gender && (
                          <p className="text-danger text-xs">
                            {errors.gender.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end my-20">
                      <button
                        type="submit"
                        className="w-45 h-45 btn py-18 px-40 rounded-0 shadow"
                        style={{ background: "#FE5014" }}
                        disabled={isLoading}
                      >
                        {isLoading ? <BtnLoader /> : "Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0">
            <SidebarLinks />
          </div>
        </div>
      </div>
      {/* pop up for change password */}
      {showModal && (
        <div>
          {/* Overlay */}
          <div
            className="modal-overlay flex-center position-fixed top-0 w-100 h-100 z-2"
            onClick={handleCloseModal}
            style={{
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          ></div>

          {/* Modal Content */}
          <div
            className="modal-content p-20 bg-white shadow-lg position-fixed top-50 start-50 translate-middle w-md-90 w-lg-auto z-3"
            style={{ maxWidth: "40rem" }}
          >
            <p className="text-lg fw-bold text-black mb-4">
              Change Your Password
            </p>
            <p className="text-sm  mb-4">
              For security reasons, please enter your current password and
              create a new one.
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Old Password */}
              <div className="mb-40 position-relative">
                <label htmlFor="oldPassword" className="text-sm form-label">
                  Old Password
                </label>
                <input
                  type={passwordVisibility.oldPassword ? "text" : "password"}
                  id="oldPassword"
                  className="common-input"
                  placeholder="Enter your old password"
                  {...register("oldPassword", {
                    required: "Old password is required",
                  })}
                />
                <span
                  className="toggle-password position-absolute top-50 inset-inline-end-0 mt-12 me-12 translate-middle-y cursor-pointer"
                  onClick={() => togglePasswordVisibility("oldPassword")}
                >
                  <i
                    className={`bi ${
                      passwordVisibility.oldPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </span>
                {errors.oldPassword && (
                  <div className="position-absolute text-xs text-danger mt-1">
                    {errors.oldPassword.message}
                  </div>
                )}
              </div>

              {/* New Password */}
              <div className="mb-40 position-relative">
                <label htmlFor="newPassword" className="text-sm form-label">
                  New Password
                </label>
                <input
                  type={passwordVisibility.newPassword ? "text" : "password"}
                  id="newPassword"
                  className="common-input"
                  placeholder="Enter your new password"
                  {...register("newPassword", {
                    required: "New password is required",
                    validate: validatePassword,
                  })}
                />
                <span
                  className="toggle-password position-absolute top-50 inset-inline-end-0 mt-12 me-12 translate-middle-y cursor-pointer"
                  onClick={() => togglePasswordVisibility("newPassword")}
                >
                  <i
                    className={`bi ${
                      passwordVisibility.newPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </span>
                {errors.newPassword && (
                  <div className="position-absolute text-xs text-danger mt-1">
                    {errors.newPassword.message}
                  </div>
                )}
              </div>

              {/* Confirm Password */}
              <div className="mb-40 position-relative">
                <label htmlFor="confirmPassword" className="text-sm form-label">
                  Confirm New Password
                </label>
                <input
                  type={
                    passwordVisibility.confirmPassword ? "text" : "password"
                  }
                  id="confirmPassword"
                  className="common-input"
                  placeholder="Confirm your new password"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === watch("newPassword") ||
                      "Passwords do not match",
                  })}
                />
                <span
                  className="toggle-password position-absolute top-50 inset-inline-end-0 mt-12 me-12 translate-middle-y cursor-pointer"
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                >
                  <i
                    className={`bi ${
                      passwordVisibility.confirmPassword
                        ? "bi-eye-slash"
                        : "bi-eye"
                    }`}
                  ></i>
                </span>
                {errors.confirmPassword && (
                  <div className="position-absolute text-xs text-danger mt-1">
                    {errors.confirmPassword.message}
                  </div>
                )}
              </div>

              {/* Actions */}
              <div className="modal-actions d-flex justify-content-end mt-26 gap-24">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="w-50  h-50 btn py-18 px-40 rounded-0 border"
                  style={{ background: "rgba(0,0,0, .5)" }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="w-50 h-50 btn py-18 px-40 rounded-0 shadow"
                  style={{ background: "#FE5014" }}
                  disabled={isLoading}
                >
                  {isLoading ? <BtnLoader /> : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/*  */}
      {/* popup for logout btn */}
      {isPopupVisible && (
        <div
          className="flex-center flex-column gap-20 px-10 shadow-lg"
          style={{
            position: "fixed",
            minWidth: "20rem",
            minHeight: "6rem",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            zIndex: 1001,
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div>You need to log out to apply changes.</div>
          <button className="btn btn-primary rounded-0" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
      {isPopupVisible && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        ></div>
      )}
    </section>
  );
};

export default ProfileSection;
